<app-header></app-header>
<div class="app-body">
  <app-sidebar></app-sidebar>
  <!-- Main content -->

  <main class="main">
    <toaster-container [toasterconfig]="toasterconfig"></toaster-container>
    <div class="card">
      <program-progress *ngIf="!smallScreen()" [user]="currentUser$ | async"></program-progress>
    </div>
    <div class="container-fluid" [@routeAnimations]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
    </div><!-- /.conainer-fluid -->
  </main>
  <!-- <app-aside></app-aside> -->
</div>
<app-footer></app-footer>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/containers/full-layout/full-layout.component.html